import { ComponentProps, useEffect, useState } from 'react'

import { AnchorLinks } from '~/components'
import { useWatchElementVisibility } from '~/hooks/use-watch-element-visibility'

const ROOT_MARGIN_SETTING = { rootMargin: '-52px 0px -50% 0px' }

const accessSectionId = 'access-section'
const facilitySectionId = 'facility-section'
const planSectionId = 'plan-section'
const pictureSectionId = 'picture-section'

export const useAnchorLinks = () => {
  const [activeSection, setActiveSection] = useState('')

  const { elementRef: accessSectionRef, isVisible: isAccessSectionVisible } =
    useWatchElementVisibility(ROOT_MARGIN_SETTING)
  const {
    elementRef: facilitySectionRef,
    isVisible: isFacilitySectionVisible,
  } = useWatchElementVisibility(ROOT_MARGIN_SETTING)
  const { elementRef: planSectionRef, isVisible: isPlanSectionVisible } =
    useWatchElementVisibility(ROOT_MARGIN_SETTING)
  const { elementRef: pictureSectionRef, isVisible: isPictureSectionVisible } =
    useWatchElementVisibility(ROOT_MARGIN_SETTING)

  useEffect(() => {
    if (isPictureSectionVisible) setActiveSection('picture')
    else if (isPlanSectionVisible) setActiveSection('plan')
    else if (isFacilitySectionVisible) setActiveSection('facility')
    else if (isAccessSectionVisible) setActiveSection('access')
  }, [
    isAccessSectionVisible,
    isFacilitySectionVisible,
    isPlanSectionVisible,
    isPictureSectionVisible,
  ])

  const links: ComponentProps<typeof AnchorLinks>['links'] = [
    {
      label: 'アクセス',
      id: accessSectionId,
      isActive: activeSection === 'access',
    },
    {
      label: '特徴・設備',
      id: facilitySectionId,
      isActive: activeSection === 'facility',
    },
    { label: 'プラン', id: planSectionId, isActive: activeSection === 'plan' },
    {
      label: '写真',
      id: pictureSectionId,
      isActive: activeSection === 'picture',
    },
  ]

  useEffect(() => {
    document.documentElement.classList.add('scroll-p-anchorLinksHeight')
    return () =>
      document.documentElement.classList.remove('scroll-p-anchorLinksHeight')
  }, [])

  return {
    links,
    accessSectionId,
    accessSectionRef,
    facilitySectionId,
    facilitySectionRef,
    planSectionId,
    planSectionRef,
    pictureSectionId,
    pictureSectionRef,
  }
}
